import { render, staticRenderFns } from "./personal_contacts_edit_modal.vue?vue&type=template&id=0b95cb62"
import script from "./personal_contacts_edit_modal.vue?vue&type=script&lang=js"
export * from "./personal_contacts_edit_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports